/* eslint-disable react/jsx-pascal-case */
import { useState } from "react";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import { useNavigate } from "react-router-dom";
import ic_right_white from "../image/ic_right_white.png";
import ic_X_white from "../image/ic_X_white.png";
import ic_제작문의 from "../image/ic_제작문의.png";
import ic_플랫폼 from "../image/ic_플랫폼.png";
import ic_고객센터 from "../image/ic_고객센터.png";

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Fixed_Div = styled.div`
  position: fixed;
  display: flex;
  border-radius: 8px;
  background-color: #383838;
  padding: 15px;
  align-items: center;
  justify-content: center;
  top: 35%;
  right: 50px;
  flex-direction: column;
  z-index: 11;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Fixed_Div2 = styled.div`
  position: fixed;
  display: none;
  border-radius: 8px;
  background-color: #383838;
  opacity: 0.9;
  padding: 15px;
  align-items: center;
  justify-content: center;
  bottom: 15px;
  z-index: 11;
  width: 90%;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Side_Btn = styled(Image)`
  cursor: pointer;
  width: 50px;
  height: 50px;
  object-fit: contain;
  box-sizing: border-box;
`;
const Side_Btn2 = styled(Image)`
  cursor: pointer;
  flex: 1;
  width: 50px;
  height: 50px;
  object-fit: contain;
  box-sizing: border-box;
`;

const Side_Bar = styled.div`
  width: 100%;
  height: 2px;
  background-color: #686868;
  margin: 15px 0px;
`;

const Call_View = styled.div`
  position: absolute;
  left: -250px;
  bottom: 0px;
  display: ${(props) => (props.$show ? "flex" : "none")};
  border-radius: 8px;
  background-color: #383838;
  width: 240px;
  align-items: center;
  height: 130px;
`;
const Call_View2 = styled.div`
  position: absolute;
  bottom: 85px;
  display: ${(props) => (props.$show ? "flex" : "none")};
  border-radius: 8px;
  background-color: #383838;
  width: 100%;
  align-items: center;
`;

const Call_Init_Div = styled.div`
  flex: 3.5;
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

const X_Btn = styled(Image)`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;

const Call_Init_Right = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #626262;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  cursor: pointer;
`;

function Side_FMS(width) {
  const navigation = useNavigate();

  const [call, set_Call] = useState(false);

  const Call_Click = () => {
    set_Call(!call);
  };

  const go_About = () => {
    navigation("/about");
    window.scrollTo({ top: 0 });
  };
  const go_Platform = () => {
    navigation("/Platform");
    window.scrollTo({ top: 0 });
  };

  return (
    <>
      <Fixed_Div>
        <Side_Btn
          onClick={() => {
            go_About();
          }}
          src={ic_제작문의}
          alt={ic_제작문의}
        />
        <Side_Bar />
        <Side_Btn
          onClick={() => {
            go_Platform();
          }}
          src={ic_플랫폼}
          alt={ic_플랫폼}
        />
        <Side_Bar />
        <Side_Btn
          onClick={() => {
            Call_Click();
          }}
          src={ic_고객센터}
          alt={ic_고객센터}
        />
        <Call_View $show={call}>
          <Call_Init_Div>
            <Content_Text $white $xbold>
              0507-1336-7115
            </Content_Text>
            <Content_Text style={{ marginTop: 5 }} $lightGray $xsmall $bold>
              평일 09:30 ~ 18:30
            </Content_Text>
            <Content_Text $lightGray $xsmall $bold>
              주말 및 공휴일 휴무
            </Content_Text>
          </Call_Init_Div>
          <Call_Init_Right
            onClick={() => {
              Call_Click();
            }}
          >
            <Image
              style={{ width: 30, height: 30 }}
              src={ic_right_white}
              alt={ic_right_white}
            />
          </Call_Init_Right>
        </Call_View>
      </Fixed_Div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Fixed_Div2>
          <Side_Btn2
            onClick={() => {
              go_About();
            }}
            src={ic_제작문의}
            alt={ic_제작문의}
          />
          <Side_Btn2
            onClick={() => {
              go_Platform();
            }}
            src={ic_플랫폼}
            alt={ic_플랫폼}
          />
          <Side_Btn2
            onClick={() => {
              Call_Click();
            }}
            src={ic_고객센터}
            alt={ic_고객센터}
          />
          <Call_View2 $show={call}>
            <Call_Init_Div>
              <Content_Text $white $xbold $xxlarge>
                0507-1336-7115
              </Content_Text>
              <Content_Text style={{ marginTop: 5 }} $lightGray $xbold $xlarge>
                평일 09:30 ~ 18:30 (주말 및 공휴일 휴무)
              </Content_Text>
            </Call_Init_Div>
            <X_Btn
              onClick={() => {
                Call_Click();
              }}
              src={ic_X_white}
            />
          </Call_View2>
        </Fixed_Div2>
      </div>
    </>
  );
}

export default Side_FMS;
